"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var useDebouncedCallback = function useDebouncedCallback(callback, delay) {
  var argsRef = (0, _react.useRef)();
  var timeoutRef = (0, _react.useRef)();

  var cleanup = function cleanup() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }; // clear timeout on unmount


  (0, _react.useEffect)(function () {
    return cleanup;
  }, []);
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // capture the latest args
    argsRef.current = args; // clear the last timer

    cleanup(); // start a new timeout

    timeoutRef.current = setTimeout(function () {
      if (argsRef.current) {
        callback.apply(void 0, _toConsumableArray(argsRef.current));
      }
    }, delay);
  };
};

var _default = useDebouncedCallback;
exports["default"] = _default;